import { ApiEndpointSpecification } from './types';
import { HttpMethod } from '../http-request';
import * as Helpers from '../api-request-helpers';
import * as Types from '../types';
import { SITE_PROFILE } from './url-constants';

type SiteProfileEndpointSpecification = ApiEndpointSpecification;
export const SiteProfileEndpointSpecification: SiteProfileEndpointSpecification = {
    url: SITE_PROFILE,
    method: HttpMethod.GET,
    requestParamsSchemaName: 'SiteProfileRequestParams',
    requestBodySchemaName: 'SiteProfileRequestBody',
    okResponseSchemaName: 'SiteProfileOkResponse',
    notOkResponseSchemaName: 'GenericNotOkResponse',
    authenticated: true,
};

export const invokeSiteProfile = Helpers.makeApiRequestFn<
    Types.SiteProfileRequestParams,
    Types.SiteProfileRequestBody,
    Types.SiteProfileOkResponse
>(SiteProfileEndpointSpecification);
